import React, { useState } from "react"

import { Modal, ModalBody, Spinner } from "reactstrap"
import failed from "../../../../assets/images/gif/failed.gif"
import { useUpdateResolveInvestorOnboardedStepMutation } from "store/api/wealthpartnerapi/onboardResolve.api"

function BusinessDetailsModel({ open, setOpen, kycData }) {
  const toggle = () => setOpen(!open)

  const [updateStep, { isLoading }] =
    useUpdateResolveInvestorOnboardedStepMutation()

  const goToStep = async (kyc_status) => {
    try {
      await updateStep({
        kyc_status,
        id: kycData.id,
      }).unwrap()
      window.location.reload()
    } catch (error) {}
  }

  return (
    <div>
      <Modal isOpen={open} toggle={toggle} centered className="custom-size">
        <ModalBody>
          <div className="signature-captured-modal-wrapper">
            <img height={"150px"} src={failed} alt="" />
            <h4>We are unable to fetch GST details on your given PAN.</h4>
            <p>Please provide necessary business details.</p>
            <button
              onClick={() => goToStep("GST_WAIVER")}
              className="btn btn-primary w-100 mt-3"
            >
              Continue
            </button>
            <h4
              style={{ cursor: "pointer" }}
              onClick={() => goToStep("PAN_GST")}
            >
              {isLoading ? <Spinner /> : <>Upload PAN Card Again</>}
            </h4>
          </div>
        </ModalBody>
      </Modal>
    </div>
  )
}

export default BusinessDetailsModel
